module.exports = __webpack_public_path__ + "img/octo.f8c7598d.png";